import styled from 'styled-components'

export const Button = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: none;
  border: none;
`

export const ButtonLink = styled(Button)`
  background: transparent;
`
